<template>
    <div v-if="form_data">
        <recharge-wallet
                :form_data="form_data"
                :recharge_wallet="recharge_wallet"

        >
        </recharge-wallet>
        <update-wallet-settings
                v-if="$can('update-info', 'card-to-card-gateway')
               "
                :form_data="form_data"
                :submit_card_to_card_settings="submit_card_to_card_settings"
        >
        </update-wallet-settings>
    </div>
</template>

<script>
import $ from "jquery"
import {KTApp} from '@/plugins/core/app'
import {cardToCardWalletService} from '@/common/api.service'
import {BASE_PATH} from '@/common/config'
import rechargeWallet from './recharge-wallet'
import updateWalletSettings from './update-wallet-settings'
import {i18n} from '@/plugins/i18n'

export default {
    name: "cardToCardWallet",
    props :['show_wallet_balance'],

    components: {
        'recharge-wallet': rechargeWallet,
        'update-wallet-settings': updateWalletSettings
    },
    data() {
        return {
            form_data: null
        }
    },
    mounted() {
        let has_access = this.$can('update-info', 'card-to-card-gateway')


        cardToCardWalletService.getSettings(has_access).then(response => {
            this.form_data = response.data.data

        }).catch(({response}) => {
            this.showMsg(form, 'danger', response.data.message)
        })
    },
    methods: {
        recharge_wallet(e) {

            let form = $('#recharge_wallet_form')
            let btn = $('#submit_btn_recharge_wallet')

            if ($('#recharge_price').val() < 10000) {
                return
            }

            KTApp.progress(btn)

            let params = {
                recharge_price: $('#recharge_price').val(),
            }
            cardToCardWalletService.rechargeWallet(params).then(response => {
                let tracking_code = response.data.data.tracking_code
               window.location = BASE_PATH + '/card-to-card/wallet/pay-recharge/' + tracking_code;
            }).catch(({response}) => {
                this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
            }).finally(() => {
                        KTApp.unprogress(btn)
                    }
            );
        },
        submit_card_to_card_settings(e) {

            let form = $('#card_to_card_settings_form')
            let btn = $('#submit_btn_card_to_card_settings')
            KTApp.progress(btn)

            let params = {
                'recharge_gateway_id': this.form_data.recharge_gateway_id
            }

            cardToCardWalletService.updateWalletSettings(params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                        KTApp.unprogress(btn)
                    }
            );
        },
    },
}
</script>

<style scoped>

</style>
